import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import {
  FlexColCenter,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';

interface Props {
  name: string;
  theme: any;
  url: string;
  img: string;
  lastParent: any;
}

function CategoryCard({ name, theme, url, img, lastParent }: Props) {
  const getName = (catName: string): string => {
    const maxLength = 50;
    if (catName.length > maxLength) {
      return catName.substring(0, maxLength) + '...';
    }
    return catName.substring(0, maxLength);
  };

  return (
    <Wrapper to={url}>
      <Image alt={`Obrázok kategórie ${name}`} src={img} />
      <CategoryNameLink to={url}>
        {lastParent ? `...  / ${lastParent.category_name}  /  ` : ''}
        {getName(name)}
      </CategoryNameLink>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  /*width: ${rem(328)};*/
  height: ${rem(72)};
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  border-radius: 4px;
  margin-right: ${rem(0)};
  /* margin-bottom: ${rem(16)}; */

  ${({ theme }) => theme.mediab.m760`
    padding: 0;
    /*width: ${rem(270)};*/
  `}
`;

const Image = styled.img`
  width: ${rem(56)};
  height: ${rem(56)};
  margin: ${rem(8)} ${rem(16)};
  min-width: ${rem(56)};
`;

const CategoryNameLink = styled(Link)`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.black};
  text-align: left;
  text-decoration: none;
  margin: ${rem(8)} ${rem(16)};
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 40ch;
  margin-left: 0;

  &:hover {
    text-decoration: underline;
  }
`;

const WithTheme: any = withTheme(CategoryCard);
export { WithTheme as SanitasCategoryCard };
